"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.min.css");
var close_icon_1 = require("../../icons/close.icon");
var toast_styles_1 = require("./toast.styles");
var success_icon_1 = require("../../icons/success.icon");
var warning_icon_1 = require("../../icons/warning.icon");
var error_icon_1 = require("../../icons/error.icon");
var button_1 = require("../button/button");
exports.ToastNotification = function (props) {
    return (react_1.default.createElement("div", { id: "toastContainer", "data-qa": "toastContainer", className: toast_styles_1.toastContainerWrapper },
        react_1.default.createElement(react_toastify_1.ToastContainer, { closeButton: react_1.default.createElement(button_1.Button, { className: toast_styles_1.closeToast, id: "toastClose", icon: true, onClick: function () { return react_toastify_1.toast.dismiss("toast"); } },
                react_1.default.createElement(close_icon_1.CloseIcon, null)), className: toast_styles_1.toastContainer, containerId: props.id, hideProgressBar: true, closeOnClick: false, draggable: false, transition: react_toastify_1.Zoom, autoClose: 4000, position: "top-center" })));
};
function toastContent(text, type) {
    react_toastify_1.toast(react_1.default.createElement("div", { className: toast_styles_1.content, id: "toast", "data-qa-type": type },
        type === "SUCCESS" && react_1.default.createElement(success_icon_1.SuccessIcon, null),
        type === "WARNING" && react_1.default.createElement(warning_icon_1.WarningIcon, null),
        type === "ERROR" && react_1.default.createElement(error_icon_1.ErrorIcon, null),
        react_1.default.createElement("div", { className: toast_styles_1.contentText, id: "toastContent", "data-qa": "toastContent" }, text)), { toastId: "toast", className: type });
}
exports.toastContent = toastContent;
